<template>
  <div id="publishing-journal-website-basic-information">
    <div class="ipub-h1 mar-b-30"
         v-if="isJournal">{{isEdit?'Edit Journal':'Add New Journal'}}</div>
    <ipub-form ref="journal-basic-information-form"
               :model="params"
               :rules="rules">
      <div class="flex">
        <div style="width:230px">
          <ipub-form-item prop="logo"
                          label="">
            <div slot="label"
                 class="ipub-p2 fw-bd mar-b-10">
              Journal Logo
              <ipub-tooltip placement="right">
                <div slot="title">
                  <div class="font-color ipub-p4">
                    Suggested Size: 230 * 230px; Only support .png; File size need to be less than 500KB.</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-cropper @change="(e)=>{handleUpload('logo', e)}"
                                 @delete="()=>{params.logo = '',params.logoName = ''} "
                                 :canWidth="230"
                                 :canHeight="230"
                                 :scales="2"
                                 :size="500"
                                 clearable
                                 :imgUrl="`${params.logo?domain+'/'+params.logo:''}`" />
          </ipub-form-item>
        </div>
        <div style="width:calc(100% - 230px)"
             class="mar-l-20">
          <div>
            <ipub-form-item prop="fullName"
                            label="Journal’s Full Name">
              <ipub-input v-model.trim="params.fullName"
                          placeholder="Enter Journal’s full name" />
            </ipub-form-item>
          </div>
          <div>
            <ipub-row :gutter="20">
              <ipub-col :span="6">
                <ipub-form-item prop="name"
                                label="Journal’s Abbreviation">
                  <ipub-input v-model.trim="params.name"
                              :disabled="true"
                              placeholder="Enter journal’s abbreviation" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item prop="nameDatabase"
                                label="Journal’s Abbreviation (Database)">
                  <ipub-input v-model.trim="params.nameDatabase"
                              placeholder="Enter journal’s abbreviation (Database)" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
          <div>
            <ipub-row :gutter="20">
              <ipub-col :span="6">
                <ipub-form-item prop="contactEmail"
                                label="Contact Email">
                  <ipub-input v-model.trim="params.contactEmail"
                              placeholder="Enter official contact email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item prop="contactEmail"
                                label="Level">
                  <ipub-select v-model="params.details.level"
                               placeholder="Level">
                    <ipub-select-option v-for="(item,key) in level"
                                        :key="key"
                                        :value="key">
                      {{item}}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="flex">
        <div style="width:230px">
          <ipub-form-item prop="cover"
                          label="Journal Cover">
            <div slot="label"
                 class="ipub-p2 fw-bd mar-b-10">
              Journal Cover
              <font class="key-color">*</font>
              <ipub-tooltip placement="right"
                            class="mar-l-10">
                <div slot="title">
                  <div class="font-color ipub-p4">
                    Suggested Size: 480 * 680px; Only support .png; File size need to be less than 500KB.</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-cropper @change="(e)=>{handleUpload('cover', e)}"
                                 :canWidth="240"
                                 :canHeight="340"
                                 :scales="1"
                                 :size="500"
                                 clearable
                                 :imgUrl="`${params.cover?domain+'/'+params.cover:''}`" />
          </ipub-form-item>
        </div>
        <div style="width:calc(100% - 230px)"
             class="mar-l-20">
          <div>
            <ipub-form-item prop="info"
                            label="Introduction (Maxmium words: 100)">
              <ipub-editor :height="340"
                           placeholder="Enter introduction of the journal here within 100 words limited"
                           v-model="params.info" />
            </ipub-form-item>
          </div>
        </div>
      </div>
      <div>
        <ipub-form-item prop="searchBackground"
                        label="Journal Search Background">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">
            Journal Search Background
            <ipub-tooltip placement="right">
              <div slot="title">
                <div class="font-color ipub-p4">
                  Suggested Size: 1920 * 230px
                  Only support .png; File size need to be less than 500KB.</div>
              </div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>

          </div>
          <div :style="{height: '150px',width: '100%', minWidth: '700px', overflow: 'hidden', fontSize: '14px'}"
               class="upload-content">
            <ipub-upload-cropper @change="(e)=>{handleUpload('searchBackground', e)}"
                                 @delete="()=>{params.searchBackground='', params.searchBackgroundName=''}"
                                 :canWidth="1440"
                                 :canHeight="150"
                                 :scales="0.5"
                                 :size="500"
                                 clearable
                                 :imgUrl="`${params.searchBackground?domain+'/'+params.searchBackground:''}`" />
          </div>

        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="openAccess"
                        label="Better Service">
          <ipub-editor :height="200"
                       placeholder="Enter the related content details…"
                       v-model="params.openAccess" />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="highVisibility"
                        label="High Visibility">
          <ipub-editor :height="200"
                       placeholder="Enter the related content details…"
                       v-model="params.highVisibility" />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="top"
                        label="Journal Rank">
          <ipub-editor :height="200"
                       placeholder="Enter the related content details…"
                       v-model="params.top" />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="rapidPublication"
                        label="Long Tradition">
          <ipub-editor :height="200"
                       placeholder="Enter the related content details…"
                       v-model="params.rapidPublication" />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="recognition"
                        label="Rapid Publication">
          <ipub-editor :height="200"
                       placeholder="Enter the related content details…"
                       v-model="params.recognition" />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item label="Author Guideline"
                          prop="authorGuide">
            <ipub-input placeholder="Enter the URL for Author Guideline"
                        v-model.trim="params.authorGuide" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item label="Open Access Permission"
                          prop="openAccessLink">
            <ipub-input placeholder="Enter the URL for Open Access Permission"
                        v-model.trim="params.openAccessLink" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="publishingAgreement">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              Publishing Policy<font class="key-color">*</font>
              <ipub-tooltip placement="right"
                            class="mar-l-10">
                <div slot="title">
                  Supported file types: pdf;
                  <div class="font-color ipub-p4">
                    Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip placement="bottomLeft"
                              class="mar-l-10 ipub-c-p">
                  <div slot="title">
                    Copy File Address
                  </div>
                  <ipub-icon type="iconduplicate"
                             @click="handleCopyAddress(params.publishingAgreement)" />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input :file="params"
                               _name="publishingAgreementName"
                               _path="publishingAgreement"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('publishingAgreement')"
                               @change="(e)=>{handleUpload('publishingAgreement', e)}" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="wordTemplate">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              Word Template<font class="key-color">*</font>
              <ipub-tooltip placement="right"
                            class="mar-l-10">
                <div slot="title">
                  Supported file types: pdf; doc; docx; txt; png; jpg; jpeg; tif; tiff; zip;
                  <div class="font-color ipub-p4">
                    Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip placement="bottomLeft"
                              class="mar-l-10 ipub-c-p">
                  <div slot="title">
                    Copy File Address
                  </div>
                  <ipub-icon type="iconduplicate"
                             @click="handleCopyAddress(params.wordTemplate)" />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input :file="params"
                               _name="wordTemplateName"
                               _path="wordTemplate"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('wordTemplate')"
                               @change="(e)=>{handleUpload('wordTemplate', e)}" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="latexTemplate">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              Latex Template<font class="key-color">*</font>
              <ipub-tooltip placement="right"
                            class="mar-l-10">
                <div slot="title">
                  Supported file types: pdf; doc; docx; txt; png; jpg; jpeg; tif; tiff; zip;
                  <div class="font-color ipub-p4">
                    Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip placement="bottomLeft"
                              class="mar-l-10 ipub-c-p">
                  <div slot="title">
                    Copy File Address
                  </div>
                  <ipub-icon type="iconduplicate"
                             @click="handleCopyAddress(params.latexTemplate)" />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input :file="params"
                               _name="latexTemplateName"
                               _path="latexTemplate"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('latexTemplate')"
                               @change="(e)=>{handleUpload('latexTemplate', e)}" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="submitLink"
                          label="Submit URL">
            <ipub-input v-model.trim="params.submitLink"
                        placeholder="Enter the URL for Submission" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="reviewLink"
                          label="Review URL">
            <ipub-input v-model.trim="params.reviewLink"
                        placeholder="Please enter the URL for Review" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="impactFactor"
                          label="Impact Factor">
            <ipub-input v-model.trim="params.impactFactor"
                        number
                        placeholder="Enter Impact Factor" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="fiveImpactFactor"
                          label="5 Years Impact Factor">
            <ipub-input v-model.trim="params.fiveImpactFactor"
                        number
                        placeholder="Enter 5 Years Impact Factor" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="citationScore"
                          label="CiteScore">
            <ipub-input v-model.trim="params.citationScore"
                        number
                        placeholder="Enter Citescore" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="impactFactorUrl"
                          label="Impact Factor URL">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              Impact Factor URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input v-model="params.impactFactorUrl"
                        placeholder="Enter the URL for Impact Factor" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="fiveImpactFactorUrl"
                          label="5 Years Impact Factor URL">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              5 Years Impact Factor URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input v-model="params.fiveImpactFactorUrl"
                        placeholder="Enter the URL for Impact Factor" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="citationScoreUrl"
                          label="CiteScore URL">
            <div class="mar-b-10 ipub-p2 fw-bd relative"
                 slot="label">
              CiteScore URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input v-model="params.citationScoreUrl"
                        placeholder="Enter the URL for Impact Factor" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="decisionDay"
                          label="Submission to First Decision period (Days)">
            <ipub-input v-model.trim="params.decisionDay"
                        number
                        placeholder="Enter the number of days from submission to first decision" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="receiveDay"
                          label="Submission to Acceptance period (Days)">
            <ipub-input v-model.trim="params.receiveDay"
                        number
                        placeholder="Enter the number of days from submission to accepted" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item :label="LANGUAGE[language].themeColor"
                        prop="mainColor">
          <ipub-radio-group v-model="params.mainColor">
            <ipub-radio v-for="(item, index) in colors"
                        :key="'Theme Color'+index"
                        :value="item">
              <div class="show-color-content"
                   :style="{background: item}"></div>
            </ipub-radio>
            <ipub-radio :value="personalColor">
              <div class="show-color-content"
                   :style="{background: personalColor}">
                <input type="color"
                       v-model="personalColor">
              </div>
            </ipub-radio>
            <font class="link-color ipub-p3">{{LANGUAGE[language].customsizeColor}}</font>
          </ipub-radio-group>
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="buildTime"
                          label="Establish Time">
            <ipub-input v-model.trim="params.buildTime"
                        number
                        placeholder="Enter the establish time of this journal" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="publicationCycle"
                          label="Publish Period">
            <ipub-input v-model.trim="params.publicationCycle"
                        placeholder="Enter the publish period of this journal" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="reviewDeadline"
                          label="Default Review Dealine(Days)">
            <ipub-input v-model.trim="params.reviewDeadline"
                        number
                        placeholder="Enter number of days for default review deadline" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="revisionDeadline"
                          label="Default Revision Deadline(Days)">
            <ipub-input v-model.trim="params.revisionDeadline"
                        number
                        placeholder="Enter number of days for default revision deadline" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="specialBufferDay"
                          label="Special Issues Buffer(Days)">
            <ipub-input v-model.trim="params.specialBufferDay"
                        number
                        placeholder="Enter number of days for special issue buffer" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="issn"
                          label="ISSN">
            <ipub-input v-model.trim="params.issn"
                        placeholder="Enter Print ISSN" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="eissn"
                          label="EISSN">
            <ipub-input v-model.trim="params.eissn"
                        placeholder="Enter Electronic ISSN" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="cdRom"
                          label="CD-ROM">
            <ipub-input v-model.trim="params.cdRom"
                        placeholder="Enter CD-ROM" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item prop="databaseInclusion"
                        label="Indexed Database">
          <div slot="label"
               class="flex ipub-p1">Indexed Database<ipub-radio-group class="mar-l-20"
                              checkBox
                              v-model="params.databaseInclusions">
              <ipub-radio checkBox
                          v-for="(value, key) in indexedDatabase"
                          :key="key"
                          :value="key"
                          style="margin-right:20px;margin-bottom:8px">
                {{ value }}

              </ipub-radio>
            </ipub-radio-group>
          </div>
          <!-- <ipub-select v-model="params.databaseInclusions"
                       mode="multiple"
                       placeholder="Indexed Database">
            <ipub-select-option v-for="(value, key) in indexedDatabase"
                                :key="key"
                                :value="key">
              {{ value }}
            </ipub-select-option>
          </ipub-select> -->

        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item prop="submitInfo"
                        label="Manuscript Submission Information (Suggested words: 100)">
          <ipub-editor :height="200"
                       v-model="params.submitInfo" />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="twitter"
                          label="Twitter">
            <ipub-input v-model.trim="params.details.twitter"
                        placeholder="Enter Twitter account" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="facebook"
                          label="Facebook">
            <ipub-input v-model.trim="params.details.facebook"
                        placeholder="Enter Fecebook account" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="linkedin"
                          label="Linkedin">
            <ipub-input v-model.trim="params.details.linkedin"
                        placeholder="Enter Linkedin account" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>

      <ipub-form-item label="Keywords"
                      prop="keywords">
        <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                    tag
                    v-model="params.keywords" />
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <ipub-button v-if="isJournal"
                   plain
                   style="width:150px"
                   @click="()=>{$router.back(-1)}"
                   type="primary">Cancel</ipub-button>
      <!-- <ipub-button plain
                   style="width:150px"
                   @click="preview"
                   type="primary">{{LANGUAGE[language].preview}}</ipub-button> -->
      <ipub-button plain
                   style="width:150px;"
                   @click="submit(false)"
                   type="primary">Save as Draft</ipub-button>
      <ipub-button style="width:150px;"
                   @click="submit(true)"
                   type="primary">Publish</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
